/**
 * @file 首页
 */
import { GetStaticProps, GetStaticPaths } from 'next';
import { ALL_LOCALES } from '@web3/base-utils';
import { getMessage } from '@web3/base-lang';
import {
  Banner,
  Tips,
  Earn,
  // Swap,
  ImportantTokens,
  MarketPlace,
  ExploreDApps,
  WalletInfoContainer,
  JoinContainer,
} from '@/containers';
import { NoSSR } from '@web3/base-components';
import { useBannerConfig } from '@/hooks/useBannerConfig';
import { useEffect } from 'react';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

import styles from './index.module.scss';

export default function Home() {
  const { init } = useBannerConfig();

  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name: Page.Home,
    });
    init();
  }, []);

  return (
    <div className={styles.container}>
      {/* 主内容区 */}
      <Banner />
      <Tips />
      <Earn />
      <NoSSR>
        {/* <Swap /> */}
        <ImportantTokens />
        <ExploreDApps />
        <WalletInfoContainer />
        <JoinContainer />
      </NoSSR>
    </div>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context.params as any;

  const messages = await getMessage('web3-home', {
    locale,
    entry: import.meta.url,
    additions: ['seoTitle', 'seoKeyword', 'seoDesc'],
  });
  return {
    props: {
      locale,
      messages,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ALL_LOCALES.map((locale) => ({
      params: {
        locale: locale.value,
      },
    })),
    fallback: true,
  };
};
